const MOBILE_BREAKPOINT_MAX = 420;
const TABLET_BREAKPOINT_MAX = 800;
const DESKTOP_BREAKPOINT_MIN = 801;
const HD_BREAKPOINT_MIN = 1201;

export const breakpoints = {
  mobile: `@media (max-width: ${MOBILE_BREAKPOINT_MAX}px)`,
  tablet: `@media (max-width: ${TABLET_BREAKPOINT_MAX}px)`,
  desktop: `@media (min-width: ${DESKTOP_BREAKPOINT_MIN}px)`,
  hd: `@media (min-width: ${HD_BREAKPOINT_MIN}px)`,
};
